import { cloneDeep, isEqual } from "lodash"
import {
  besoinsSpecifiquesBloc,
  childInfoBloc,
  comportementBloc,
  contentHeader,
  declarationBloc,
  deroulementBloc,
  docHead,
  docSign,
  droitImageBloc,
  participationBloc,
  transportBloc,
} from "../components/inputs/createConsentFile/docBlocs"
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
import PDFMerger from "pdf-merger-js"
import { CONSENT_FIELDS } from "./constants/forms"
import { slugify } from "./utils"

pdfMake.vfs = pdfFonts.pdfMake?.vfs ?? pdfFonts.vfs

export const getEditedFormProperties = (formDb, formLocal) => {
  let formToSave = {}
  Object.keys(formLocal).forEach((property) => {
    if (!isEqual(formDb[property], formLocal[property])) {
      // A GARDER !!!! PERMET DE RÉCUPÉRER LA DIFFÉRENCE JUSQU'AU NIVEAU 2
      // if (isPlainObject(formLocal[property])) {
      //   Object.keys(formLocal[property]).forEach((subProperty) => {
      //     if (!isEqual(formDb[property][subProperty], formLocal[property][subProperty])) {
      //       formToSave[property] = {
      //         ...formToSave[property],
      //         [subProperty]: formLocal[property][subProperty],
      //       }
      //     }
      //   })
      // } else {
      formToSave[property] = formLocal[property]
      // }
    }
  })
  return { form: { ...formToSave, event: formLocal.event } }
}

export const isFileNeeded = (inputs, reg) =>
  Object.keys(inputs).filter((input) => CONSENT_FIELDS.includes(input) && inputs[input] === 1 && reg?.[input] === true)

export const eventNeedFile = (inputs) => CONSENT_FIELDS.some((field) => !!inputs[field])
export const regNeedFile = (reg) => CONSENT_FIELDS.some((field) => !!reg[field])
export const regNeededFields = (reg) => CONSENT_FIELDS.filter((field) => !!reg[field])

export const cleanProperties = (obj) => {
  let newObj = cloneDeep(obj)
  Object.keys(newObj).forEach((k) => {
    newObj[k] = typeof newObj[k] == "string" ? newObj[k].trim() : newObj[k]
  })
  return newObj
}

export const getDocDef = (event, logos, child, inputs, filename, reg) => {
  let content = []

  content.push(childInfoBloc(child))

  if (inputs?.diet) content.push(besoinsSpecifiquesBloc(reg))

  if (inputs?.risks_consent) content.push(deroulementBloc(reg))

  if (inputs?.comportement) content.push(comportementBloc(reg))

  if (inputs?.media_consent) content.push(droitImageBloc(reg))

  if (inputs?.transportation) content.push(transportBloc(reg))

  if (inputs?.participation) content.push(participationBloc())

  content.push(declarationBloc())
  content.push(docSign())

  return {
    ...docHead(filename),
    header: () => contentHeader(event.name, logos),
    footer: (currentPage, pageCount) => ({
      text: `${currentPage}/${pageCount}`,
      alignment: "center",
      margin: [0, 20, 0, 0],
      fontSize: 9,
      color: "#888888",
    }),
    pageMargins: [40, 120, 40, 60],
    content,
  }
}

export const getConsentUnil = async (unilDoc) => {
  let file
  switch (unilDoc) {
    case "mint":
      file = await fetch("/unil_mint.pdf")
      break
    default:
      file = await fetch("/consentUnil.pdf")
  }
  return await file.arrayBuffer()
}

export const getConsentPDF = async (event, child, logos, unilDoc, inputs, reg) => {
  const hasConsentSections = CONSENT_FIELDS.some((field) => !!inputs?.[field]) || !!inputs?.comportement
  const hasUnil = !!inputs?.unil_survey
  if (!hasConsentSections && !hasUnil) return null
  const pdfName = slugify(`consent-${event.name}-${child.firstname}-${child.lastname}`)

  const regWantsUnil = !!reg?.unil_survey

  if (hasConsentSections && regWantsUnil) {
    const merger = new PDFMerger()
    const pdfDoc = pdfMake.createPdf(getDocDef(event, logos, child, inputs, pdfName, reg))
    const buffer = await new Promise((resolve) => pdfDoc.getBuffer((b) => resolve(b)))
    await merger.add(buffer)
    await merger.add(await getConsentUnil(unilDoc))
    await merger.save(pdfName)
  } else if (hasConsentSections) {
    pdfMake.createPdf(getDocDef(event, logos, child, inputs, pdfName, reg)).download(pdfName)
  } else if (regWantsUnil) {
    const merger = new PDFMerger()
    await merger.add(await getConsentUnil(unilDoc))
    await merger.save(pdfName)
  }
}
